module.exports = __webpack_public_path__ + "static/media/bmw_zertifikat_2008.3bebfac6.jpg";